import { Layers } from "lucide-react";

/**
 * Shared "Social Hub" wordmark + tinted square lockup rendered at the top
 * of every auth card. Matches the mockup auth-logo block (login.html L273-L277,
 * forgot-password.html L203-L206, reset-password.html L226-L229,
 * accept-invite.html L196-L199): 28×28 accent square with layered-cubes icon,
 * 16px Outfit wordmark to the right.
 */
export function BrandMark() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        marginBottom: 20,
        fontFamily: "var(--font-display)",
        fontWeight: 600,
        fontSize: 16,
        color: "var(--text-main)",
      }}
    >
      <span
        aria-hidden
        style={{
          width: 28,
          height: 28,
          background: "var(--accent)",
          borderRadius: 7,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          boxShadow: "var(--bevel-light)",
        }}
      >
        <Layers size={16} />
      </span>
      Social Hub
    </div>
  );
}
